import * as React from 'react';
import ReactProgressiveList from 'react-progressive-list';
import ImageBox from '../../../../../atoms/ImageBox';
import { ImageBoxData } from '../../../../../services/types';

export interface ListingProps {
  lang?: 'ro' | 'en'
  data: ImageBoxData[];
  extraFilters: string[];
}

export default class Listing extends React.Component<ListingProps, any> {
  get content() {
    const {
      props: { data, extraFilters },
    } = this;

    const renderRow = (index: number) => (
      <ImageBox key={index} showExtraText={extraFilters.length !== 0} {...data[index]} />
    );

    const Loader = () => <div>Loading</div>;

    if (data.length === 0) {
      return (
        <h2 className="placeholder">
          {this.props.lang === 'en' ? 'Nothing matching your filters' : 'Nu am găsit nimic conform filtrelor aplicate.'}
        </h2>
      );
    } else {
      return (
        <div className="progressiveList">
          {data.map((entry, key) => <ImageBox key={key} showExtraText={extraFilters.length !== 0} {...entry} />)}
        </div>
      )
    }
  }

  public render() {
    return <section className="contentList">{this.content}</section>;
  }
}
